import SEO from '../components/SEO'
import './Legal.css'

export default function CookiePolicy() {
  return (
    <>
      <SEO title="Cookie Policy" description="Learn how NexCore Solutions uses cookies and similar technologies on our website and products." path="/cookies" />
      <section className="page-hero"><div className="container"><p className="section-label">Legal</p><h1 className="section-title">Cookie Policy</h1><p className="section-subtitle">Last updated: 1 June 2025</p></div></section>
      <section className="legal-section"><div className="container"><div className="prose">
        <p>This Cookie Policy explains how NexCore Solutions Private Limited ("NexCore") uses cookies and similar tracking technologies when you visit nexcoresolutions.com or use our products. By accepting cookies when prompted, you consent to our use of them as described here.</p>

        <h2>1. What Are Cookies?</h2>
        <p>Cookies are small text files placed on your device by a website when you visit it. They are widely used to make websites work more efficiently and to provide information to the site's owners. Cookies can be "session cookies" (deleted when you close your browser) or "persistent cookies" (remain on your device for a set period or until deleted).</p>

        <h2>2. Types of Cookies We Use</h2>

        <h3>Strictly Necessary Cookies</h3>
        <p>These cookies are essential for the website to function and cannot be switched off. They are usually set in response to actions you take such as logging in, filling in forms, or setting preferences. You can configure your browser to block them, but parts of the site may not work.</p>
        <ul>
          <li><strong>nexcore_session</strong> — Maintains your login session. Duration: Session.</li>
          <li><strong>nexcore_csrf</strong> — Protects against cross-site request forgery. Duration: Session.</li>
          <li><strong>nexcore_cookie_consent</strong> — Stores your cookie preferences. Duration: 1 year.</li>
        </ul>

        <h3>Analytics & Performance Cookies</h3>
        <p>These cookies allow us to count visits and understand how visitors move around our website. They help us measure and improve performance. All information is aggregated and anonymous.</p>
        <ul>
          <li><strong>_ga, _ga_*</strong> — Google Analytics, measures site usage. Duration: 2 years.</li>
          <li><strong>_gid</strong> — Google Analytics, distinguishes users. Duration: 24 hours.</li>
          <li><strong>_gat</strong> — Google Analytics, throttles request rate. Duration: 1 minute.</li>
        </ul>

        <h3>Functional Cookies</h3>
        <p>These cookies enable enhanced functionality and personalisation such as remembering your language preference or region.</p>
        <ul>
          <li><strong>nexcore_lang</strong> — Stores language preference. Duration: 1 year.</li>
          <li><strong>nexcore_region</strong> — Stores region/currency preference. Duration: 1 year.</li>
        </ul>

        <h3>Marketing & Targeting Cookies</h3>
        <p>These cookies may be set by our advertising partners to build a profile of your interests and show relevant ads on other sites. They do not store personal information directly, but identify your browser and device uniquely.</p>
        <ul>
          <li><strong>_fbp</strong> — Facebook Pixel, tracks ad conversions. Duration: 3 months.</li>
          <li><strong>_gcl_au</strong> — Google Ads conversion tracking. Duration: 3 months.</li>
          <li><strong>li_fat_id</strong> — LinkedIn Insight Tag. Duration: 30 days.</li>
        </ul>

        <h2>3. Third-Party Cookies</h2>
        <p>Some cookies are placed by third-party services that appear on our pages. We do not control these third-party cookies. Please refer to the respective third parties' privacy policies: Google Analytics (policies.google.com), LinkedIn (linkedin.com/legal/privacy-policy), and Meta/Facebook (facebook.com/privacy/policy).</p>

        <h2>4. How to Manage Cookies</h2>
        <p>You can control and delete cookies through your browser settings. Note that restricting cookies may impact your experience of our website. Browser guides:</p>
        <ul>
          <li>Google Chrome: Settings → Privacy and security → Cookies</li>
          <li>Mozilla Firefox: Options → Privacy & Security → Cookies and Site Data</li>
          <li>Safari: Preferences → Privacy → Manage Website Data</li>
          <li>Microsoft Edge: Settings → Cookies and site permissions</li>
        </ul>
        <p>You can also opt out of Google Analytics across all websites by installing the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.</p>

        <h2>5. Updates to This Policy</h2>
        <p>We may update this Cookie Policy as we introduce new technologies or as legal requirements change. We will notify you of significant changes through our website.</p>

        <h2>6. Contact Us</h2>
        <p>For questions about our use of cookies, email <a href="mailto:privacy@nexcoresolutions.com">privacy@nexcoresolutions.com</a>.</p>
      </div></div></section>
    </>
  )
}
